import { SectionDetails } from '@/app/types/marketing/SectionDetails';
import GeneratorLandingPage from '@/components/generator-landing-page/GeneratorLandingPage';
import { ListBulletIcon } from '@heroicons/react/20/solid';
import { LightBulbIcon } from '@heroicons/react/24/outline';
import {
  CircleStackIcon,
  ClipboardDocumentListIcon,
  DocumentDuplicateIcon
} from '@heroicons/react/24/solid';
import { TableCellsIcon } from '@heroicons/react/24/solid';
import overviewImage from '@/public/pdf-example-screenshot.png';

const imageSection: SectionDetails = {
  miniText: 'Optimized studying',
  title: 'Flashcards in seconds',
  image: overviewImage,
  description:
    'Limbiks offers a fully optimized study experience by instantly generating the exact flashcards you need.',
  features: [
    {
      name: 'Multiple flashcard types.',
      description:
        'Limbiks can generate question and answer, fill in the blank, and image occlusion flashcards. Choose the type that works best for you.',
      icon: TableCellsIcon
    },
    {
      name: 'Select number of flashcards.',
      description:
        'Whether you want as many as possible or just a few, specify exactly how many flashcards you want Limbiks to create.',
      icon: CircleStackIcon
    },
    {
      name: 'Choose pages.',
      description:
        'Generate from every page or enter the specific pages you want to be used for your flashcards.',
      icon: DocumentDuplicateIcon
    }
  ]
};

const featureSection: SectionDetails = {
  miniText: 'Be test ready',
  title: 'Learn with our advanced study tools',
  description:
    'Limbiks offers a wide variety of study tools so you can master your flashcards.  Our tools are custom built with all of the latest AI advancements to ensure you are getting the best possible study experience.  ',
  features: [
    {
      name: 'AI Study Guides',
      description:
        'Generate study guides with every upload.  Limbiks uses AI to analyze your content and build a focused study guide of everything you need to know. All study guides can be downloaded and printed.',
      icon: ClipboardDocumentListIcon
    },
    {
      name: 'Multiple choice questions',
      description:
        'Study every flashcard as a multiple choice question.  Whether you use our quiz tool or take a full practice test, multiple choice questions are a perfect way to learn all of your material.',
      icon: ListBulletIcon
    },
    {
      name: 'Hints and Explanations',
      description:
        'Limbiks has hints and explanations anytime you need a little extra help.  Use hints if you just need a little help and use explanations for a complete understanding',
      icon: LightBulbIcon
    }
  ]
};

export default function _PdfToFlashcards() {
  return (
    <GeneratorLandingPage
      imageSection={imageSection}
      featureSection={featureSection}
      title="PDF to Flashcards"
      description="Upload any PDF and generate a comprehensive deck of flashcards in seconds. Learn with our powerful study tools or download flashcards to use with any other flashcard app."
    />
  );
}
